import { createContext } from "react";

export interface MainLayoutContextType {
  title?: string;
  [key: string]: unknown;
}

const MainLayoutContext = createContext<MainLayoutContextType | undefined>(undefined);

export default MainLayoutContext;
